import React from "react";
import Sidebar from "../components/sidebar";
import ChatArea from "../components/chat-area";
import UseChat from "../utils/use-chat";

const ChatAlfred = () => {
  const { handleSelectConversation, conversations } = UseChat();

  return (
    <div className="flex w-full h-screen bg-[#0f1829] overflow-hidden">
      <Sidebar handleSelectConversation={handleSelectConversation} conversations={conversations} />
      <div className="flex-1 overflow-hidden min-w-0">
        <ChatArea />
      </div>
    </div>
  );
};

export default ChatAlfred;
